import RecaptchaV2 from 'components/recaptchaV2';
import { RegistroContext } from 'contexts/registroContext/RegistroContext';
import {
  Button,
  Checkbox,
  CheckCircleIcon,
  Col,
  Container,
  PercentLoaderIcon,
  Row,
  TableWithOverflow,
} from 'plataforma-fundacao-componentes';
import { ColumnObject } from 'plataforma-fundacao-componentes/dist/components/tableWithOverflow/TableWithOverflow';
import { useContext, useMemo, useState } from 'react';
import { languageValues } from 'utils/LanguageUtils';

export default function Presenca() {
  const {
    state,
    changeAccountAttendance,
    confirmAssociatePresence,
    isRecaptchaV2,
  } = useContext(RegistroContext);

  const [recaptchaV2Token, setRecaptchaV2Token] = useState<string>('');

  const columns = useMemo(() => {
    return [
      {
        key: 'checkbox',
        value: languageValues.pages.presenca.table.presenca,
        props: { align: 'center' },
      },
      {
        key: 'account',
        value: languageValues.pages.presenca.table.conta,
        props: { align: 'center' },
      },
      {
        key: 'agency',
        value: languageValues.pages.presenca.table.agencia,
        props: { align: 'center' },
      },
      {
        key: 'name',
        value: languageValues.pages.presenca.table.nome,
        props: { align: 'center' },
      },
    ] as ColumnObject[];
  }, []);

  const lines = useMemo(() => {
    if (!state.dados?.accounts || !state.dados.accounts.length) return [];
    return state.dados?.accounts.map((conta) => {
      return {
        ...conta,
        key: conta.id,
        checkbox: (
          <Checkbox
            value={conta.flagAttendance}
            onChange={(v) => {
              changeAccountAttendance(v, conta.id);
            }}
          />
        ),
      };
    });
  }, [changeAccountAttendance, state.dados]);

  return (
    <Container verticalPadding>
      <Row>
        <Col className='title'>{languageValues.pages.presenca.title}</Col>
        <Col className='sub-title nunito'>
          {languageValues.pages.presenca.subtitle}
        </Col>
        <Col>
          {lines.length ? (
            <TableWithOverflow
              columns={columns}
              lines={lines}
              showTopNavigator={false}
            />
          ) : undefined}
        </Col>
        {isRecaptchaV2 && (
          <Col>
            <RecaptchaV2
              onChange={(value) => value && setRecaptchaV2Token(value)}
            />
          </Col>
        )}
        <Col buttonActionsCol end>
          <Button
            disabled={
              state.loading ||
              (isRecaptchaV2 && !recaptchaV2Token) ||
              !state.dados?.accounts.some((a) => a.flagAttendance)
            }
            leftIcon={
              state.loading ? (
                <PercentLoaderIcon indefinido />
              ) : (
                <CheckCircleIcon />
              )
            }
            onClick={() => {
              confirmAssociatePresence(recaptchaV2Token);
            }}
          >
            {languageValues.buttons.confirm}
          </Button>
        </Col>
      </Row>
    </Container>
  );
}
